export interface DepositRewards {
  cashAward: CashAward;
  stockAward: StockAward;
}

export interface CashAward {
  awardRecordId: number;
  depositGrade: DepositGrade;
  status: ClaimStatus;
}

export interface StockAward {
  awardRecordId: number;
  accumulateDepositAmount: string;
  tradingCount: number;
  status: ClaimStatus;
}

export const enum DepositGrade {
  GRADE_1 = 0, // Deposit amount less than 200
  GRADE_2 = 1, // Deposit amount between 200 and 999
  GRADE_3 = 2, // Deposit amount between 1000 and 2499
  GRADE_4 = 3, // Deposit amount 2500 or more
}

export const enum ClaimStatus {
  UNABLE_TO_CLAIM = 0,
  NOT_CLAIMED = 1,
  CLAIMED = 2,
}

export const enum PromotionType {
  NEW_USER = 1, // 拉新
  DEPOSIT = 3, // 入金
}
